import React, { useState, useEffect } from 'react';
import Contact from '../../Contact/Contact';
import profilePageimage from '../../../Assets/images/profilePageimage.png';
import Swal from 'sweetalert2';
import apiClient from '../../../Api/apiClient';
import { PHOTO_BASE_URL } from '../../../Api/config';
import LocationInpc from '../../Location/LocationInpc';
const Profile = () => {
  const [profileImage, setProfileImage] = useState(null);
  const [profileId, setProfileId] = useState('');
  const [profileData, setProfileData] = useState({
    name: '',
    description: '',
    organization: '',
    designation: '',
    email: '',
    mobile: '',
    photo: null,
    district_id: null,
    upazila_id: null,
  });

  const userType = localStorage.getItem('user_type');

  const [selectedLocation, setSelectedLocation] = useState({
    districtId: null,
    districtName: '',
    upazilaId: null,
    upazilaName: '',
  });

  // Handle location selection
  const handleLocationSelect = (
    districtId,
    districtName,
    upazilaId,
    upazilaName
  ) => {
    setSelectedLocation({ districtId, districtName, upazilaId, upazilaName });
    setProfileData(prev => ({
      ...prev,
      district_id: districtId,
      upazila_id: upazilaId,
    }));
  };

  useEffect(() => {
    const fetchProfileData = async () => {
      try {
        let url = '/user/profile';
        if (userType === 'affiliator') {
          url = '/affiliator/profile';
        }
        const response = await apiClient.get(url);

        // console.log(response.data.data);
        setProfileId(response.data.data.id);

        // Assuming the response contains profile data
        setProfileData({
          name: response.data.data.full_name || '',
          description: response.data.data.description || '',
          organization: response.data.data.organization_name || '',
          designation: response.data.data.designation || '',
          email: response.data.data.email || '',
          mobile: response.data.data.phone || '',
          address: response.data.data.address || '',
          photo: response.data.data.photo || null,
          district_id: response.data.data.district_id || null,
          upazila_id: response.data.data.upazila_id || null,
        });

        setSelectedLocation({
          districtId: response.data.data.district_id || null,
          districtName: response.data.data.district || '', // Set district as a string
          upazilaId: response.data.data.upazila_id || null,
          upazilaName: response.data.data.upazila || '', // Set upazila as a string
        });

        setProfileImage(
          response.data.data.photo
            ? `${PHOTO_BASE_URL}${response.data.data.photo}`
            : null
        );
      } catch (error) {
        console.error('Error fetching profile data:', error);
      }
    };

    fetchProfileData();
  }, []);

  const handleSaveClick = async event => {
    event.preventDefault();

    if (!profileId) {
      Swal.fire('Error!', 'Profile ID missing. Try reloading.', 'error');

      Swal.fire({
        title: 'Error!',
        text: 'Profile ID missing. Try reloading.',
        icon: 'error',
        confirmButtonText: 'Okay',
        customClass: {
          popup: 'w-72 h-auto p-3',
          title: 'text-sm',
          content: 'text-xs',
          confirmButton:
            'bg-DefaultColor text-white px-4 py-1 text-sm rounded-md',
        },
      });
      return;
    }

    const formData = new FormData();

    // Append only non-null values
    if (profileData.photo) formData.append('photo', profileData.photo);
    if (profileData.name) formData.append('full_name', profileData.name);
    if (profileData.description)
      formData.append('description', profileData.description);
    if (profileData.organization)
      formData.append('organization_name', profileData.organization);
    if (profileData.designation)
      formData.append('designation', profileData.designation);
    if (profileData.email) formData.append('email', profileData.email);
    if (profileData.mobile) formData.append('phone', profileData.mobile);
    if (profileData.address) formData.append('address', profileData.address);

    // Append selected location data
    if (selectedLocation.districtId) {
      formData.append('district_id', selectedLocation.districtId);
    }
    if (selectedLocation.upazilaId) {
      formData.append('upazila_id', selectedLocation.upazilaId);
    }

    // Debugging: Log FormData entries
    for (const [key, value] of formData.entries()) {
      console.log(`${key}:`, value);
    }

    try {
      // let url = `/user/profile/update/${profileId}`;
      let url = '/user/profile/update';
      if (userType === 'affiliator') {
        url = '/affiliator/profile/update';
      }
      const response = await apiClient.patch(
        url, // Ensure profileId is used
        formData
      );
      // console.log('Update response:', response.data);

      Swal.fire({
        title: 'Success!',
        text: 'Profile updated successfully.',
        icon: 'success',
        confirmButtonText: 'Okay',
        customClass: {
          popup: 'w-72 h-auto p-3',
          title: 'text-sm',
          content: 'text-xs',
          confirmButton:
            'bg-DefaultColor text-white px-4 py-1 text-sm rounded-md',
        },
      });
    }
    //  catch (error) {
    //   console.error('Error updating profile:', error);

    //   let errorMessage = 'Something went wrong!';
    //   if (error.response && error.response.data) {
    //     errorMessage = Object.values(error.response.data).flat().join('\n');
    //   }

    //   Swal.fire({
    //     title: 'Failed!',
    //     text: errorMessage,
    //     icon: 'error',
    //     confirmButtonText: 'Okay',
    //     customClass: {
    //       popup: 'w-72 h-auto p-3',
    //       title: 'text-sm',
    //       content: 'text-xs',
    //       confirmButton:
    //         'bg-DefaultColor text-white px-4 py-1 text-sm rounded-md',
    //     },
    //   });
    // }
     catch (error) {
          console.error('Error:', error);
          const errorMessage = error.response?.data?.message;
          Swal.fire({
            // icon: 'error',
            title: 'Error!',
            // text: 'Failed to send. Please try again.',
            text: errorMessage,
            customClass: {
              popup: 'w-72 h-auto p-3',
              title: 'text-lg',
              content: 'text-xs',
              confirmButton: 'bg-headerBtn text-white px-4 py-1 text-sm rounded-md',
            },
          });
        }
  };

  const handleInputChange = e => {
    const { name, value, files } = e.target;

    if (name === 'photo' && files && files.length > 0) {
      const file = files[0];

      // Validate file type
      if (!['image/png', 'image/jpeg', 'image/webp'].includes(file.type)) {
        Swal.fire({
          title: 'Not Accept!',
          text: 'Please upload a valid Image.',
          icon: 'error',
          customClass: {
            popup: 'w-72 h-auto p-3',
            title: 'text-sm',
            content: 'text-xs',
            confirmButton:
              'bg-DefaultColor text-white px-4 py-1 text-sm rounded-md',
          },
        });
        e.target.value = null;
        return;
      }

      // **Update state for instant preview**
      const imageURL = URL.createObjectURL(file);
      setProfileImage(imageURL);

      // Set valid file to profileData
      setProfileData({
        ...profileData,
        [name]: file,
      });
    } else {
      setProfileData({
        ...profileData,
        [name]: value,
      });
    }
  };

  const handleImageUpload = (e, setImage) => {
    const file = e.target.files[0];
    if (file) {
      setImage(file); // Store the actual File object
    }
  };

  return (
    <>
      <div className="flex flex-col lg:flex-row  justify-between md:px-20 px-2 md:py-24 md:mt-20 mt-32 py-1 md:text-sm text-xs">
        {/* Left Side: Image */}
        <div className="lg:w-1/3 w-full mb-8  lg:mb-0 text-center ">
          <h1 className="font-bold md:text3xl text-xl mb-2">My Profile</h1>
          <p className="text-sm text-gray-500">
            Update your profile to keep your information accurate and up to
            date.
          </p>
          <img
            src={profilePageimage}
            alt="Profile Image"
            className="w-full h-auto object-cover rounded-lg md:block hidden"
          />
        </div>

        {/* Right Side: Form */}
        <div className="bg-white shadow-lg rounded-lg md:p-4 p-2 lg:w-1/2 w-full">
          <form onSubmit={handleSaveClick} className="md:space-y-4 space-y-3">
            {/* Profile Picture and Full Name */}
            <div className="bg-ProfileUpdateColor p-2 rounded">
              <div className="flex flex-col xl:flex-row space-x-4 items-center md:mb-6 mb-4">
                <div className="w-20 h-20 rounded-full bg-gray-200 mb-0">
                  {profileImage && (
                    <img
                      src={profileImage}
                      alt="Profile"
                      className="rounded-full w-full h-full object-cover"
                    />
                  )}
                </div>
                <div className="relative">
                  <input
                    type="file"
                    accept="image/*"
                    name="photo"
                    onChange={handleInputChange}
                    // onChange={e => handleImageUpload(e, setProfileImage)}
                    className="absolute top-0 left-0 w-full h-full opacity-0 cursor-pointer"
                  />
                  <h1 className="mb-1 text-sm text-purofileUpdateTextColor">
                    Profile Picture
                  </h1>
                  <button
                    type="button"
                    className="px-6 xl:py-1 py-1 bg-gray-200 border-2 border-gray-300 text-purofileUpdateTextColor xl:text-sm text-sm rounded-md shadow-sm button-text w-full max-w-44 mb-1"
                  >
                    Chose a photo
                  </button>
                  <p className="text-xs text-gray-500">
                    This file must be JPG, JPEG, PNG, SVG etc. And file size not
                    be more than 1 MB.
                  </p>
                </div>
              </div>

              {/* About self */}
              <div className="flex flex-col md:flex-row  md:space-x-4 space-y-2 md:space-y-0 md:ml-0 ml-3">
                <label className="md:w-1/3 w-full text-purofileUpdateTextColor font-medium">
                  About Yourself
                </label>
                <textarea
                  type="text"
                  name="description"
                  value={profileData.description}
                  onChange={handleInputChange}
                  placeholder=" write something about yourself"
                  className="w-full p-2 border border-gray-400 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                />
              </div>
            </div>

            {/* Name */}
            <div className="flex flex-col md:flex-row items-center md:space-x-4 space-y-2 md:space-y-0 md:mt-0 mt-6">
              <label className="md:w-1/3 w-full text-purofileUpdateTextColor font-medium">
                Name
              </label>
              <input
                type="text"
                name="name"
                value={profileData.name}
                onChange={handleInputChange}
                placeholder="Enter your name"
                className="w-full p-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>

            {/* Organization */}
            <div className="flex flex-col md:flex-row items-center md:space-x-4 space-y-2 md:space-y-0">
              <label className="md:w-1/3 w-full text-purofileUpdateTextColor font-medium">
                Organization
              </label>
              <input
                type="text"
                name="organization"
                value={profileData.organization}
                onChange={handleInputChange}
                placeholder="Enter your organization"
                className="w-full p-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>

            {/* Designation */}
            <div className="flex flex-col md:flex-row items-center md:space-x-4 space-y-2 md:space-y-0">
              <label className="md:w-1/3 w-full text-purofileUpdateTextColor font-medium">
                Designation
              </label>
              <input
                type="text"
                name="designation"
                value={profileData.designation}
                onChange={handleInputChange}
                placeholder="Enter your designation"
                className="w-full p-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>

            {/* Email */}
            <div className="flex flex-col md:flex-row items-center md:space-x-4 space-y-2 md:space-y-0">
              <label className="md:w-1/3 w-full text-purofileUpdateTextColor font-medium">
                Email
              </label>
              <input
                type="text"
                name="email"
                value={profileData.email}
                onChange={handleInputChange}
                placeholder="Enter your email"
                className="w-full p-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>

            {/* Mobile */}
            <div className="flex flex-col md:flex-row items-center md:space-x-4 space-y-2 md:space-y-0">
              <label className="md:w-1/3 w-full text-purofileUpdateTextColor font-medium">
                Mobile
              </label>
              <input
                type="text"
                name="mobile"
                value={profileData.mobile}
                onChange={handleInputChange}
                placeholder="Enter your mobile number"
                className="w-full p-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                readOnly
              />
            </div>

            <LocationInpc
              onSelectLocation={handleLocationSelect}
              selectedLocation={selectedLocation}
            />
            {/* Submit Button */}
            <div className="flex justify-end">
              <button
                type="submit"
                className="md:w-36 w-full p-2 bg-publishTenderBtn text-white rounded-md hover:bg-publishTenderBtn transition duration-300"
              >
                Update Profile
              </button>
            </div>
          </form>
        </div>
      </div>
      <Contact />
    </>
  );
};

export default Profile;




